/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductVariantShippingOrderDetail {
  brandEquity?: number;
  brandId?: number;
  brandName?: string;
  dateCreated?: Date;
  dateSyncERP?: Date;
  editionId?: number;
  expiration?: string;
  externalId?: number;
  internalEAN?: string;
  personId?: number;
  personName?: string;
  productId?: number;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  referenceName?: string;
  shippingOrderId?: number;
  shippingOrderItemId?: number;
  shippingOrderStatus?: number;
  shippingOrderStatusName?: string;
  shippingOrderTypeId?: number;
  shippingOrderTypeName?: string;
  shippingTotal?: number;
  statusOrderDescription?: string;
  theme?: string;
}
